import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state to show error UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can log the error to an error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            // Custom error UI
            return (
                <div className="error-boundary p-4 m-4 border border-red-400 rounded-lg bg-red-50">
                    <h2 className="text-red-800 text-xl font-bold mb-2">Something went wrong!</h2>
                    <p className="text-red-600 mb-4">
                        An unexpected error has occurred. Please reload the page or contact technical support.
                    </p>
                    {process.env.NODE_ENV === 'development' && (
                        <details className="text-sm">
                            <summary className="cursor-pointer text-red-700 font-semibold">
                                View error details (development only)
                            </summary>
                            <div className="mt-2 p-2 bg-red-100 rounded">
                                <pre className="whitespace-pre-wrap text-xs">
                                    {this.state.error && this.state.error.toString()}
                                    <br />
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </div>
                        </details>
                    )}
                    <button 
                        onClick={() => window.location.reload()}
                        className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                    >
                        Reload page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;